<template>
    <div>

        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />
       
        <div class="row">
            <div class="col-2 pe-0">
                <vue-select :options="filtro_processos" v-model="filtro_processos_selects" :label-by="formatNameProcesso"
                            placeholder="Selecione um Processo" search-placeholder="Pesquise" searchable close-on-select
                            clear-on-select :min="1" class="form-control shadow-v2">
                </vue-select>
                <Field name="idProcesso" label="Processo" type="hidden" rules="min_value:1" v-model="filtro_processos_selects.idProcesso" />
            </div>            
            <div class="col">
                <button class="btn btn-new-crud" @click="newProcessoCrud">
                    <i class="fas fa-regular fa-plus"></i><span class="ms-2">Adicionar Novo Processo</span>
                </button>
            </div>
            <div class="col d-flex" style="flex-direction: row-reverse;" v-if="processoCrud.idProcesso > 0">
                <button class="btn btn-red" style="border-color: transparent;"
                        :class="isPublicado ? 'bg-success' : 'bg-red-gnp'" v-if="bntAtivo == true" @click="func_crud()">
                    <span class="">Contratação Publicada</span>
                </button>
            </div>
        </div>

        <div v-if="showDadosProcesso != false">
            <Form ref="ABC" @submit="submitForm">
                <div class="d-flex">
                    <div class="col ms-2">
                        <div class="col mt-1">
                            <label class="form-label">Proposta *</label>
                            <vue-select :options="filtro_proposta" v-model="filtro_proposta_selects"
                                        :label-by="formatNameProposta" placeholder="Selecione uma Proposta"
                                        search-placeholder="Pesquise" searchable close-on-select clear-on-select :min="1"
                                        class="form-control shadow-v2" :class="{ filled: filtro_proposta_selects.idProposta > 0 }"
                                        :readonly="idEtapaAtual == 15 || idEtapaAtual == 14">
                            </vue-select>
                            <Field name="idProposta" label="Lista" type="hidden" rules="min_value:1" v-model="filtro_proposta_selects.idProposta" />
                            <ErrorMessage name="idProposta" class="form-error" v-show="showErrorMessage" />
                        </div>

                        <div class="row mt-1">
                            <div class="d-flex">

                                <div class="col m-1">
                                    <label class="form-label">Contato *</label>
                                    <vue-select :options="filtro_contato" v-model="filtro_contato_selects"
                                                :label-by="formatNameContato" placeholder="Digite o nome da Contato e selecione"
                                                search-placeholder="Pesquise" searchable close-on-select clear-on-select :min="1"
                                                class="form-control shadow-v2" :readonly="idEtapaAtual == 15 || idEtapaAtual == 14"
                                                :class="{ filled: filtro_contato_selects.idPessoa > 0 }">
                                    </vue-select>
                                    <Field name="idPessoa" label="Contato" type="hidden" rules="min_value:1" v-model="filtro_contato_selects.idPessoa" />
                                    <ErrorMessage name="idPessoa" class="form-error" v-show="showErrorMessage" />
                                </div>
                                <div class="col m-1">
                                    <label  class="form-label">Nome</label>
                                    <Field name="nmCliente" label="Nome" type="text" class="form-control shadow-v2"
                                           rules="required" v-model="processoCrud.nmCliente"
                                           :class="{ filled: processoCrud.nmCliente }" readonly />
                                    <ErrorMessage name="nmCliente" class="form-error" v-show="showErrorMessage" />
                                </div>
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="d-flex">
                                <div class="col m-1">
                                    <label  class="form-label">Telefone</label>
                                    <Field name="nrTelefoneCliente" label="Telefone" type="text"
                                           class="form-control shadow-v2"
                                           v-model="processoCrud.nrTelefoneCliente" v-maska="'(##) ####-####'"
                                           :class="{ filled: processoCrud.nrTelefoneCliente }" />
                                </div>
                                <div class="col m-1">
                                    <label  class="form-label">Celular</label>
                                    <Field name="nrCelularCliente" label="Telefone" type="text"
                                           class="form-control shadow-v2" 
                                           v-model="processoCrud.nrCelularCliente" v-maska="'(##) #####-####'"
                                           :class="{ filled: processoCrud.nrCelularCliente }" />
                                </div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="col m-1">
                                <label  class="form-label">E-mail</label>
                                <Field name="dsEmail" label="E-mail" type="text" class="form-control shadow-v2"
                                       rules="required" v-model="processoCrud.dsEmail"
                                       :class="{ filled: processoCrud.dsEmail }" readonly />
                                <ErrorMessage name="dsEmail" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col m-1">
                                <label  class="form-label">Número Processo</label>
                                <Field name="nrProcessoCliente" label="Número Processo" type="text"
                                       class="form-control shadow-v2" v-model="processoCrud.nrProcessoCliente"
                                       :class="{ filled: processoCrud.nrProcessoCliente }"
                                       :readonly="idEtapaAtual == 15 || idEtapaAtual == 14" />
                                <ErrorMessage name="nrProcessoCliente" class="form-error" v-show="showErrorMessage" />
                            </div>

                        </div>
                        <div class="d-flex">
                            <div class="col m-1">
                                <label class="form-label">Modalidade *</label>
                                <vue-select :options="filtro_modalidade" v-model="filtro_modalidade_selects"
                                            :label-by="formatNameModalidade" placeholder="Selecione a Modalidade"
                                            search-placeholder="Pesquise" searchable close-on-select clear-on-select :min="1"
                                            class="form-control shadow-v2" :readonly="idEtapaAtual == 15 || idEtapaAtual == 14"
                                            :class="{ filled: verificaFilled(processoCrud.tpModalidade) }">
                                </vue-select>
                                <Field name="tpModalidade" label="Modalidade" type="hidden" v-model="filtro_modalidade_selects.tpModalidade" rules="required" />
                                <ErrorMessage name="tpModalidade" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col m-1">
                                <label  class="form-label">Valor Proposta</label>
                                <CurrencyInput id="vlProposta" v-bind:value="processoCrud.vlProposta" v-model="processoCrud.vlProposta" :options="{ currency: 'BRL', precision: 2 }" :class="{ filled: processoCrud.vlProposta > 0 }" readonly />
                                <ErrorMessage name="vlProposta" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="col m-1">
                                <label  class="form-label">Data Abertura *</label>
                                <DateInput v-model="processoCrud.dtAbertura" class="col-12"
                                           :readonly="processoCrud.idProcesso > 0 || idEtapaAtual == 15"
                                           :customWidth="customWidthDate" dateFormat="DD/MM/YYYY" />
                                <ErrorMessage name="dtAbertura" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col m-1">
                                <label  class="form-label">Data Previsão *</label>
                                <DateInput v-model="processoCrud.dtPrevisaoConclusao" class="col-12"
                                           :readonly="processoCrud.idProcesso > 0 || idEtapaAtual == 15"
                                           :customWidth="customWidthDate" dateFormat="DD/MM/YYYY" />
                                <ErrorMessage name="dtPrevisaoConclusao" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col m-1">
                                <label  class="form-label">Data Previsão Atualizado</label>
                                <DateInput v-model="processoCrud.dtPrevisaoConclusaoAtualizado" class="col-12"
                                           :readonly="processoCrud.idProcesso == 0 || idEtapaAtual == 15 || idEtapaAtual == 14"
                                           :customWidth="customWidthDate" dateFormat="DD/MM/YYYY" />
                                <ErrorMessage name="dtPrevisaoConclusaoAtualizado" class="form-error"
                                              v-show="showErrorMessage" />
                            </div>
                        </div>


                        <div class="d-flex mt-2" v-if="(processoCrud.idEvento <= 0 || processoCrud.idEvento == null)">
                            <div class="col m-1">
                                <label class="form-control-checkbox me-4">
                                    <input type="checkbox" v-model="processoCrud.flFinalizaOcorrencia" /> Finalizar Ticket
                                </label>
                            </div>                           
                        </div>

                    </div>
                    <div class="col m-2" v-if="processoCrud.idProcesso == 0">

                    </div>
                    <div class="col ps-2" v-else>
                        <div class="row ps-2 d-flex mt-2">
                            <div class="d-flex justify-content-between">
                                <label class="form-label">Etapa Atual: <strong>{{ etapa.nmEtapa }}</strong></label>
                            </div>
                            <div class="d-flex flex-column mb-2">
                                <div class="progress">
                                    <div class="progress-bar" :class="etapa.nrPerncentualConcluido == 100
                                        ? 'bg-success'
                                        : etapa.nrPerncentualConcluido == 101
                                            ? 'bg-danger'
                                            : 'bg-primary'
                                        " role="progressbar" :aria-valuenow="etapa.nrPerncentualConcluido"
                                        aria-valuemin="0" aria-valuemax="100"
                                        :style="{ width: etapa.nrPerncentualConcluido + '%' }"><span
                                            v-if="etapa.nrPerncentualConcluido != 101">{{ etapa.nrPerncentualConcluido }}%
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ms-2 mb-2">
                            <label class="form-label ps-0">Etapa Atual</label>
                            <vue-select :options="etapas" v-model="filtro_etapas_selects" :label-by="(e) => (e.nmEtapa)"
                                placeholder="Selecione uma etapa" search-placeholder="Pesquise" searchable close-on-select
                                clear-on-select :min="1" class="form-control shadow-v2" :readonly="idEtapaAtual == 15">
                            </vue-select>
                            <Field name="idEtapa" label="Lista" type="hidden" rules="min_value:1" v-model="filtro_etapas_selects.idEtapa" />
                            <ErrorMessage name="idEtapa" class="form-error" v-show="showErrorMessage" />
                        </div>
                       
                        
                        
                        
                        
                        <!--<div v-if="processoCrud.idEvento > 0">
                            
                            <div class="ms-2 mb-2" v-if="filtro_etapas_selects.idEtapa == 15">
                                <div :class="{ displayHide: isFracasso == 15 }">
                                    <label class="form-label">Motivo Fracasso</label>
                                    <textarea class="form-control shadow-v2" id="txt_dsMotivoFracasso" rows="1"
                                              v-model="processoCrud.dsMotivoFracasso"
                                              :readonly="processoCrud.dsMotivoFracasso != null && processoCrud.dsMotivoFracasso != ''"></textarea>
                                    <Field name="dsMotivoFracasso" label="Descrição do Motivo" type="hidden"
                                           rules="required" v-model="processoCrud.dsMotivoFracasso" />
                                    <ErrorMessage name="dsMotivoFracasso" class="form-error" v-show="showErrorMessage" />

                                </div>
                            </div>

                            <div v-if="processoCrud.dsMotivoFracasso != null && processoCrud.dsMotivoFracasso != ''">
                                <div class="mt-0 ms-2 mb-3">
                                    <div :class="{ displayHide: isFracassoText == 15 }">
                                        <label class="form-label">Motivo Fracasso</label>
                                        <textarea class="form-control shadow-v2" id="txt_dsMotivoFracasso" rows="1"
                                            v-model="processoCrud.dsMotivoFracasso"
                                            :readonly="processoCrud.dsMotivoFracasso != null && processoCrud.dsMotivoFracasso != ''"></textarea>
                                        <Field name="dsMotivoFracasso" label="Descrição do Motivo" type="hidden"
                                            rules="required" v-model="processoCrud.dsMotivoFracasso" />
                                        <ErrorMessage name="dsMotivoFracasso" class="form-error" v-show="showErrorMessage" />
                                    </div>
                                </div>
                            </div>
                        </div>-->
                        <!--<div v-else>-->
                            <div class="mt-0 ms-2 mb-3" v-if="filtro_etapas_selects.idEtapa == 15">
                                <label class="form-label">Motivo Fracasso</label>
                                <textarea class="form-control shadow-v2" id="txt_dsMotivoFracasso" rows="1"
                                    v-model="processoCrud.dsMotivoFracasso" :readonly="idEtapaAtual == 15"></textarea>
                                <Field name="dsMotivoFracasso" label="Descrição do Motivo" type="hidden" rules="required"
                                    v-model="processoCrud.dsMotivoFracasso" />
                                <ErrorMessage name="dsMotivoFracasso" class="form-error" v-show="showErrorMessage" />
                            </div>
                        <!--</div>-->
                        <div class="row table-dados w-100 mt-2" style="padding-left: 16px;" v-if="processoCrud.idProposta > 0">
                            <DataTable :url_ajax="getUrlHistorico()" :customHeightPaginate="dincamicHeigthDataTablePG"
                                :customHeight="dincamicHeigthDataTable" :ajax_set_result="setHistorico"
                                @grid_refreshed="gridRefreshed" :refresh="refresh_grid" :filtros="filtro" method="GET"
                                :qtd_registros_por_pagina="8" :is_table="true" :footer_fixed="false" :headers="headers"
                                :pBtnsSlot="true" :is_NotLoading="NotLoading" :is_modal="true"
                                :sizeWidBooton="dincamicWidFooterDT" :request_api="'comercial'">
                            </DataTable>
                        </div>
                    </div>
                </div>
            </Form>
        </div>

        <modal-warper target="ModalConfirmacao_Publicacao2" :show="isOpenModalConfirmacao2" @close="isOpenModalConfirmacao2 = false">
            <ModalConfirmacao id="Publicacao2" :title="'Publicar'" :description="''" :show="isOpenModalConfirmacao2" :red="isPublicado
                ? 'Deseja remover a publicação desse cliente?'
                : 'Deseja marcar que esse cliente teve a Contratação Publicada em Diário Oficial?'
                " :action="isPublicado ? 'Remover' : 'Publicar'" @actionReturn="publicar" :isDelete="false" />
        </modal-warper>

    </div>
</template>

<script>

    import axios from 'axios';
    import OcorrenciaInfo from '@/components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import VueNextSelect from 'vue-next-select'
    import 'vue-next-select/dist/index.min.css'
    import DateInput from "@/components/App/DateInput.vue";
    import DataTable from '@/components/App/Datatable.vue';
    import ModalConfirmacao from '@/components/App/ModalConfirmacao.vue';
    import ModalWarper from '@/components/App/ModalWarper.vue'
    import moment from 'moment';
    import CurrencyInput from '@/components/App/CurrencyInput.vue'

    export default {
        name: 'Processo',
        emits: [
            'setFlNovoProcesso',
            'handleButtonProcessoTab'
        ],
        components: {
            OcorrenciaInfo,
            'vue-select': VueNextSelect,
            DateInput,
            ModalConfirmacao,
            ModalWarper,
            DataTable,
            CurrencyInput
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
            idProcesso: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                ocorrencia: {},
                dados: {},


                hasRegister: false,
                qntProcessos: [],

                filtro_contato: [],
                filtro_contato_selects: { idPessoa: 0 },

                etapas: [],
                filtro_etapas_selects: { idEtapa: 0 },
                etapa: {
                    idEtapa: 0,
                    nmEtapa: '',
                    nrPerncentualConcluido: 0
                },

                idEtapaAtual: 0,
                processoCrud: {
                    idProcesso: 0,
                    idPessoa: 0,
                    idInstituicao: 0,
                    idContrato: 0,
                    IdModulo: 0,
                    idEtapaAtual: 0,
                    nmCliente: '',
                    nrCpfCnpj: '',
                    nrTelefoneCliente: '',
                    nrCelularCliente: '',
                    dsEmail: '',
                    vlProposta: 0,
                    nrProcessoCliente: '',
                    /* dtAbertura: new Date().toLocaleDateString('pt-BR'),*/
                    dtAbertura: '',
                    dtPrevisaoConclusao: '',
                    idOcorrencia: 0,
                    dtPrevisaoConclusaoAtualizado: '',
                    tpModalidade: '',
                    tpPessoa: '',
                    idProposta: 0,
                    dsMotivoFracasso: "",
                    flFinalizaOcorrencia: true
                },

                filtro_modalidade: [{ tpModalidade: 'Dispensa' }, { tpModalidade: 'Inexigibilidade' }, { tpModalidade: 'Pregão eletrônico' }],
                filtro_modalidade_selects: [],

                filtro_proposta: [],
                filtro_proposta_selects: { idProposta: 0 },

                filtro_processos: [],
                filtro_processos_selects: {},

                showErrorMessage: false,

                refresh_grid: false,

                filtro: [
                    { active: true },
                ],

                headers: [
                    { class: 'col', name: 'dsMovimento', text: 'Movimento', order: 0 },
                    { class: 'col', name: 'dtMovimento', text: 'Data', order: 0 },
                    { class: 'col', name: 'dsLogin', text: 'Consultor(a)', order: 0 }
                ],
                NotLoading: false,
                isOpenModalConfirmacao2: false,
                bntAtivo: true,
                isPublicado: false,
                isFracasso: 0,
                isFracassoText: 0,
                showDadosProcesso: false,
                validNewProcesso: false,
                getIdProcesso: 0,
                dincamicHeigthDataTablePG: '',
                dincamicWidFooterDT: '',
                dincamicHeigthDataTable: '',
                customWidthDate: '',
                postPublicado: {
                    idInstituicaoMonitoramento: 0,
                    idModuloMonitoramento: 0,
                },

                validaProcessoSelect: 0
            }
        },
        mounted() {
            this.getEtapa();
            this.getOcorrencia();
            this.updateDinamicHeigthDataTable();
            window.addEventListener('resize', this.updateDinamicHeigthDataTable);
        },
        updated() {
            this.updateDinamicHeigthDataTable();
        },
        methods: {
            verificaFilled(filled) {
                if (filled == '' || typeof filled === 'undefined') {
                    return false;
                } else {
                    return true;
                }
            },
            updateDinamicHeigthDataTable() {
                if (window.innerWidth <= 1400) {
                    this.customWidthDate = 'width:91%'
                    if (this.processoCrud.idEtapaAtual == 15) {
                        this.dincamicHeigthDataTable = 'max-height: calc(100vh - 25.2rem);margin-top:0 !important';
                        this.dincamicHeigthDataTablePG = 'max-height: calc(100vh - 28rem);margin-top:0 !important';
                        this.dincamicWidFooterDT = 'width: 105.5%;left: 3px;';

                    } else {
                        this.dincamicHeigthDataTablePG = 'max-height: calc(100vh - 22.6rem);margin-top:0 !important';
                        this.dincamicWidFooterDT = 'width: 105.5%;left: 3px;';
                        this.dincamicHeigthDataTable = 'max-height: calc(100vh - 20rem);margin-top:0 !important';
                    }

                } else if (window.innerWidth >= 3500) {
                    this.customWidthDate = 'width:103%'

                    this.dincamicHeigthDataTablePG = 'width:101.3%;left:-12px;';
                } else {
                    this.customWidthDate = 'width:96%'
                    if (this.processoCrud.idEtapaAtual == 15) {
                        this.dincamicWidFooterDT = 'width:104%;left:3px;';
                        this.dincamicHeigthDataTable = 'max-height: calc(100vh - 37.6rem);margin-top:0 !important';
                        this.dincamicHeigthDataTablePG = 'max-height: calc(100vh - 40.4rem);margin-top:0 !important';
                    } else {
                        this.dincamicHeigthDataTablePG = 'max-height: calc(100vh - 35.1rem);margin-top:0 !important';
                        this.dincamicWidFooterDT = 'width:104%;left:3px;';
                        this.dincamicHeigthDataTable = 'max-height: calc(100vh - 32.3rem);margin-top:0 !important';
                    }


                }
            },

            getProcesso() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/AcompanhamentoProcesso/GetProcessosByIdOcorrencia?idOcorrencia=' + $this.idOcorrencia, {
                    headers: this.$api.getTokenComercial()
                }).then(response => {
                    const data = response.data.data.rows;
                    const selectAllOption = { idProcesso: 0, vlProposta: "Sem processo" };

                    $this.filtro_processos = [selectAllOption, ...data];

                    if ($this.filtro_processos.length == 2) {
                        $this.filtro_processos_selects = $this.filtro_processos[1];
                    }

                    if ($this.validaProcessoSelect > 0) {
                        $this.$nextTick(() => {
                            $this.filtro_processos_selects = $this.filtro_processos.find((g) => {
                                return g.idProcesso == $this.validaProcessoSelect;
                            });
                        });
                    }

                    if (this.idProcesso > 0) {
                        $this.filtro_processos_selects = $this.filtro_processos.find((g) => {
                            return g.idProcesso == $this.idProcesso;
                        });
                    }

                });
            },
            getIsPublicado() {
                let $this = this;
                if ($this.ocorrencia.idInstituicao > 0) {
                    axios.get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API +
                        "/InstituicaoMonitoramento/GetVerificaMonitorado?" +
                        "idInstituicao=" +
                        $this.processoCrud.idInstituicao +
                        "&idModulo=" +
                        $this.processoCrud.idModulo,
                        {
                            headers: $this.$api.getTokenComercial(),
                            params: "",
                        }
                    )
                        .then((response) => {
                            $this.isPublicado = response.data.data;
                        });
                }
            },
            publicar() {
                let $this = this;

                if ($this.isPublicado == false) {
                    $this.postPublicado.idInstituicaoMonitoramento = $this.processoCrud.idInstituicao;
                    $this.postPublicado.idModuloMonitoramento = $this.processoCrud.idModulo;

                    axios
                        .post(
                            process.env.VUE_APP_ROOT_COMERCIAL_API + "/InstituicaoMonitoramento/Post",
                            $this.postPublicado,
                            { headers: $this.$api.getTokenComercial() }
                        )
                        .then(function (response) {
                            $this.isOpenModalConfirmacao2 = false;
                            $this.isPublicado = true;
                        })
                        .catch(function (error) {
                            var msg = "Ocorreu um erro inesperado";
                            if (error.response) {
                                if (error.response.data.erros != "") {
                                    msg = error.response.data.errors[0];
                                } else {
                                    msg = error.response.data.msg;
                                }
                            }

                            $this.$toast.show("alert", msg, true);
                        });
                } else {
                    axios
                        .delete(
                            process.env.VUE_APP_ROOT_COMERCIAL_API +
                            "/InstituicaoMonitoramento/Delete?idInstituicaoMonitoramento=" +
                            $this.processoCrud.idInstituicao +
                            "&idModuloMonitoramento=" +
                            $this.processoCrud.idModulo,
                            {
                                headers: $this.$api.getTokenComercial(),
                            }
                        )
                        .then((response) => {
                            $this.isOpenModalConfirmacao2 = false;
                            $this.isPublicado = false;
                        })
                        .catch((error) => {
                            var msg = "Ocorreu um erro inesperado";
                            if (error.response) {
                                if (error.response.data.erros != "") {
                                    msg = error.response.data.errors[0];
                                } else {
                                    msg = error.response.data.msg;
                                }
                            }

                            $this.$toast.show("alert", msg, true);
                        });
                }


            },
            zerarInformacoes() {
                this.processoCrud = {
                    idProcesso: 0,
                    idPessoa: 0,
                    idInstituicao: 0,
                    idOcorrencia: 0,
                    idContrato: 0,
                    idModulo: 0,
                    idEvento: 0,
                    idEtapaAtual: 0,
                    nmCliente: '',
                    nmContatoCliente: '',
                    nrCpfCnpj: '',
                    nrTelefoneCliente: '',
                    nrCelularCliente: '',
                    dsEmail: '',
                    vlProposta: 0,
                    nrProcessoCliente: '',
                    /*     dtAbertura: new Date().toLocaleDateString('pt-BR'),*/
                    dtAbertura: '',
                    dtPrevisaoConclusao: '',
                    dtPrevisaoConclusaoAtualizado: '',
                    tpModalidade: '',
                    tpPessoa: '',
                    idProposta: 0,
                    dsMotivoFracasso: '',
                    flFinalizaOcorrencia: true
                };
                this.filtro_modalidade_selects = [{ tpModalidade: '' }];
                this.filtro_etapas_selects = { idEtapa: 0 };
                this.filtro_proposta_selects = { idProposta: 0 };
                this.filtro_contato_selects = { idPessoa: 0 };
                this.isFracassoText = 0;
                this.isFracasso = 0;

                (this.etapa = {
                    idEtapa: 0,
                    nmEtapa: "",
                    nrPerncentualConcluido: 0,
                })

                this.processoCrud.idInstituicao = this.ocorrencia.idInstituicao;
                this.processoCrud.idPessoa = this.ocorrencia.idPessoa;
            },
            formatNameProcesso(name) {
                if (name.dtAbertura == undefined) {
                    return `${name.vlProposta}`
                } else {
                    return `${name.dtAbertura}-${name.vlProposta}`
                }
            },
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial()
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    $this.getDadosOcorrencia();
                })
            },
            getProcessoOcorrencia() {
                let $this = this;

                if ($this.filtro_processos_selects.idProcesso > 0) {
                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/AcompanhamentoProcesso/GetOcorrencia?idOcorrencia=' + $this.idOcorrencia + '&idProcesso=' + $this.filtro_processos_selects.idProcesso, {
                        headers: $this.$api.getTokenComercial()
                    }).then(response => {
                        $this.processoCrud = response.data.data;

                        $this.processoCrud.idInstituicao = $this.ocorrencia.idInstituicao;

                        if ($this.ocorrencia.idPessoa > 0) {
                            $this.processoCrud.idPessoa = $this.ocorrencia.idPessoa;
                        }

                        $this.idEtapaAtual = $this.processoCrud.idEtapaAtual;
                        $this.processoCrud.tpModalidade = $this.processoCrud.tpModalidade == "Pregão eletr" ? "Pregão eletrônico" : $this.processoCrud.tpModalidade

                        $this.showDadosProcesso = true;
                        if ($this.processoCrud.idEtapaAtual == 15) {
                            $this.$emit('setFlNovoProcesso', false);
                            $this.$emit('handleButtonProcessoTab', 0);
                        }

                        $this.getProposta();
                    }).catch(function (error) {

                    });
                } else {
                    if (this.validNewProcesso != true) {
                        $this.zerarInformacoes();
                        $this.showDadosProcesso = false;
                    } else {
                        $this.zerarInformacoes();
                    }
                }
            },
            getContatos() {
                let $this = this;

                if ($this.ocorrencia.idPessoa > 0) {
                    axios.get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API + "/Pessoa/GetPessoaById?id=" + $this.ocorrencia.idPessoa,
                        {
                            headers: $this.$api.getTokenComercial()
                        }
                    ).then((response) => {
                        var array = [response.data.data];
                        $this.filtro_contato = array;
                        $this.iniciou();
                    });
                }
                else {
                    axios.get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API + "/PessoaInstituicao/GetPessoasInstituicao?idInstituicao=" + $this.ocorrencia.idInstituicao + '&idProcesso=' + $this.processoCrud.idProcesso,
                        {
                            headers: $this.$api.getTokenComercial(),
                            params: "",
                        }
                    ).then((response) => {
                        $this.filtro_contato = response.data.data;
                        $this.iniciou();
                    });
                }
            },
            iniciou() {
                let $this = this;

                $this.reloadGrid();
                $this.getIsPublicado();


                setTimeout(function () {

                    if ($this.processoCrud.idPessoa > 0 && $this.filtro_contato.length > 0) {
                        $this.filtro_contato_selects = $this.filtro_contato.find(p => {
                            return p.idPessoa == $this.processoCrud.idPessoa
                        });
                    }
                    else if ($this.processoCrud.idPessoa > 0 && $this.filtro_contato.length > 0) {
                        $this.filtro_contato_selects = $this.filtro_contato.find(p => {
                            return p.idPessoa == $this.filtro_proposta_selects.idPessoa
                        });
                    }
                    if ($this.processoCrud.tpModalidade != null) {
                        $this.filtro_modalidade_selects = $this.filtro_modalidade.find(m => {
                            return m.tpModalidade == $this.processoCrud.tpModalidade
                        });
                    }
                    if ($this.processoCrud.idProposta > 0) {

                        $this.filtro_proposta_selects = $this.filtro_proposta.find((g) => {
                            return g.idProposta == $this.processoCrud.idProposta;
                        });

                        if ($this.filtro_proposta_selects == undefined || $this.filtro_proposta_selects == null) {
                            $this.filtro_proposta_selects = { idProposta: 0 };
                            $this.filtro_proposta_selects.idProposta = $this.processoCrud.idProposta;

                            var propostaInvalida = { flFracassada: true, idProposta: $this.filtro_proposta_selects.idProposta, dsProposta: "Proposta fracassada ou inválida !" };
                            $this.filtro_proposta.unshift(propostaInvalida);

                            setTimeout(() => {
                                $this.filtro_proposta_selects = $this.filtro_proposta.find((g) => {
                                    return g.idProposta == $this.processoCrud.idProposta;
                                });
                            }, 400)
                        }
                    }

                    $this.filtro_etapas_selects = $this.etapas.find((g) => {
                        return g.idEtapa == $this.processoCrud.idEtapaAtual;
                    });

                    $this.etapa = $this.etapas.find((e) => {
                        return e.idEtapa == $this.processoCrud.idEtapaAtual;
                    });

                }, 350);
            },
            formatNameContato(pessoa) {
                return pessoa.nmPessoa;
            },
            formatNameModalidade(modalidade) {
                return modalidade.tpModalidade;
            },
            formatNameEtapa(etapa) {
                return etapa.nmEtapa;
            },
            formatNameProposta(proposta) {
                if (proposta.flFracassada) {
                    return proposta.dsProposta;
                }
                if (this.ocorrencia.idEvento > 0) {
                    return `Nº/Ano:${proposta.nrProposta}/${proposta.nrAno}|Valor:${proposta.vlProposta}|Qtd Participantes:${proposta.qtdParticipantes}|Data Geração:${proposta.dtGeracao}`;

                } else {
                    return `Nº/Ano:${proposta.nrProposta}/${proposta.nrAno}|Valor:${proposta.vlProposta}|Qtd Usuários:${proposta.qtdUsuarios}|Data Geração:${proposta.dtGeracao}`;
                }
            },
            getProposta() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/GetPropostasOcorrencia?idOcorrencia=' + $this.idOcorrencia + '&idProcesso=' + $this.processoCrud.idProcesso + '&flSemProcesso=true', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.filtro_proposta = response.data.data.rows;
                    $this.getContatos();
                })
            },
            getEtapa() {
                let $this = this;
                axios.get(
                    process.env.VUE_APP_ROOT_COMERCIAL_API +
                    "/AcompanhamentoProcessoEtapas/GetPorcentagem?idEtapaAtual=" +
                    $this.processoCrud.idEtapaAtual, { headers: $this.$api.getTokenComercial() })
                    .then((response) => {
                        $this.etapas = response.data.data;
                    });
            },
            getDadosOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetDadosOcorrencia?idOcorrencia=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial()
                }).then(response => {
                    $this.dados = response.data.data;
                    $this.getProcesso();
                })
            },
            newProcessoCrud() {
                let $this = this;

                $this.idEtapaAtual = 0;

                $this.validNewProcesso = true;
                $this.filtro_processos_selects = {};

                $this.showDadosProcesso = true;

                $this.$emit('setFlNovoProcesso', true);
                $this.$emit('handleButtonProcessoTab', 0);

                this.$nextTick(() => {
                    $this.getProposta();
                });
            },
            gridRefreshed(data_ajax) {
                let $this = this;

                $this.refresh_grid = false;
            },
            reloadGrid() {
                let $this = this;

                $this.refresh_grid = true;
            },
            getUrlHistorico() {
                let $this = this

                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/AcompanhamentoProcessoEtapas/GetHistorico?idProcesso=' + $this.processoCrud.idProcesso
            },
            setHistorico(result) {
                result.forEach((value, index) => {
                    if (value.dtMovimento) {
                        value.dtMovimento = moment(value.dtMovimento).format("DD/MM/YYYY");
                    }
                })
                return result;
            },
            func_crud() {
                this.isOpenModalConfirmacao2 = true;
            },
            submitForm() {
                let $this = this

                $this.processoCrud.idOcorrencia = $this.idOcorrencia;
                $this.processoCrud.idInstituicao = $this.ocorrencia.idInstituicao;
                $this.processoCrud.idContrato = $this.dados.idContrato;
                $this.processoCrud.IdModulo = $this.ocorrencia.idModulo;

                if ($this.ocorrencia.idPessoa > 0) { $this.processoCrud.tpPessoa = "F"; $this.processoCrud.idPessoa = $this.ocorrencia.idPessoa; }
                else { $this.processoCrud.tpPessoa = "J"; }

                if ($this.processoCrud.dtPrevisaoConclusaoAtualizado == '') {
                    $this.processoCrud.dtPrevisaoConclusaoAtualizado = $this.processoCrud.dtPrevisaoConclusao;
                }

                $this.$refs.ABC.validate()
                    .then(isValid => {
                        if (isValid.valid) {

                            if (!$this.$phoneValidator.validatePhoneCell($this.processoCrud.nrTelefoneCliente, $this.processoCrud.nrCelularCliente)) {
                                $this.$toast.show('alert', 'Telefone ou celular é obrigatório e deve estar completo!', true);
                                return;
                            }

                            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/AcompanhamentoProcesso/Post', $this.processoCrud, { headers: $this.$api.getTokenComercial() })
                                .then(function (response) {
                                    $this.validaProcessoSelect = response.data.data;
                                    $this.getProcessoOcorrencia();
                                    $this.getProcesso();

                                    if ($this.processoCrud.idEtapaAtual != 14 && $this.processoCrud.idEtapaAtual != 15) {
                                        $this.$emit('handleButtonProcessoTab', $this.validaProcessoSelect);
                                        $this.$emit('setFlNovoProcesso', false);
                                    }
                                    $this.$emit('reloadGridOcorrencias');
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }
                                    $this.$toast.show('alert', msg, true);
                                });
                            $this.showErrorMessage = false;
                        }
                        else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatorios';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
        },
        watch: {
            idOcorrencia(newVal, oldVal) {
                this.getOcorrencia(newVal);
            },
            validNewProcesso(n, o) {
                if (n == false) {
                    this.showDadosProcesso = false;
                }
            },
            filtro_processos_selects(newVal, oldVal) {
                this.getProcessoOcorrencia();
                if (newVal.idProcesso == 0) {
                    this.$emit('setFlNovoProcesso', true);
                    this.$emit('handleButtonProcessoTab', 1);
                    this.validNewProcesso = false;
                } else if (newVal.idProcesso > 0) {
                    this.$emit('setFlNovoProcesso', false);
                    this.$emit('handleButtonProcessoTab', newVal.idProcesso);
                }
            },
            filtro_contato_selects(newVal, oldVal) {
                if (newVal) {
                    this.processoCrud.nmCliente = newVal.nmPessoa;

                    if (this.processoCrud.idPessoa != newVal.idPessoa) {
                        this.processoCrud.nrTelefoneCliente = newVal.nrTelefone;
                        this.processoCrud.nrCelularCliente = newVal.nrCelular;
                        this.processoCrud.idPessoa = newVal.idPessoa;
                    }

                    this.processoCrud.dsEmail = newVal.dsEmail;
                    this.processoCrud.nrCpfCnpj = newVal.nrCpf;
                }
            },
            filtro_modalidade_selects(newVal, oldVal) {
                if (newVal) {
                    this.processoCrud.tpModalidade = newVal.tpModalidade;
                }
            },
            filtro_proposta_selects(newVal, oldVal) {
                if (newVal) {
                    this.processoCrud.vlProposta = newVal.vlProposta;
                    this.processoCrud.idProposta = newVal.idProposta;

                    try {
                        if (newVal?.idPessoa > 0 && this.filtro_contato.length > 0) {
                            const contatoEncontrado = this.filtro_contato.find(p => p.idPessoa === newVal.idPessoa);

                            if (contatoEncontrado) {
                                this.filtro_contato_selects = contatoEncontrado;
                            }
                        }
                    } catch (error) {
                        console.error("Erro ao validar e atribuir filtro_contato_selects:", error);
                    }
                }
            },
            filtro_etapas_selects(newVal, oldVal) {
                if (newVal) {
                    this.processoCrud.idEtapaAtual = newVal.idEtapa;
                }
            }
        },
    }

</script>

<style scope lang="scss">
    .displayHide {
        display: none;
    }
</style>